export {
  RouterProvider,
  openLink,
  getSyntheticLinkProps,
  useSyntheticLinkProps,
  shouldClientNavigate,
  useRouter,
  useLinkProps,
  handleLinkClick
} from '../../../src/utils/openLink';
